import _extends from "@babel/runtime-corejs3/helpers/extends";
/* eslint-disable react/display-name */
import React from 'react';
import { IconBase, SVG_DEFAULT_SIZE } from '../icon';
const variants = {
  mgb: (className, size) => /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    width: size || SVG_DEFAULT_SIZE,
    height: size || SVG_DEFAULT_SIZE,
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M2 5.991L7.87 12 9 10.847l-4.744-4.85L9 1.147 7.87 0z"
  }))
};
export const IconChevronLeft = props => /*#__PURE__*/React.createElement(IconBase, _extends({}, props, {
  variants: variants
}));